import { render } from "./IdeasDetail.vue?vue&type=template&id=d2bb8c0a"
import script from "./IdeasDetail.vue?vue&type=script&lang=ts"
export * from "./IdeasDetail.vue?vue&type=script&lang=ts"

import "./IdeasDetail.vue?vue&type=style&index=0&id=d2bb8c0a&lang=css"
script.render = render

export default script